var data = {
  "width": 24,
  "height": 24,
  "body": "<g id=\"evaCheckmarkSquare2Fill0\"><g id=\"evaCheckmarkSquare2Fill1\"><path id=\"evaCheckmarkSquare2Fill2\" fill=\"currentColor\" d=\"M18 3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3Zm-1.7 6.61l-4.57 6a1 1 0 0 1-.79.39a1 1 0 0 1-.79-.38l-2.44-3.11a1 1 0 0 1 1.58-1.23l1.63 2.08l3.78-5a1 1 0 1 1 1.6 1.22Z\"/></g></g>"
};
exports.__esModule = true;
exports.default = data;